import {cloneDeep, isEmpty} from "lodash";
import {UPDATE_PRODUCT_SELECTIONS} from "../store/mutation-types";
import ProductSelection from "../domains2/orders/ProductSelection";

export default {
	data() {
		return {};
	},
	computed: {
		additionsProductNotSelected() {
			if(!isEmpty(this.groupsWithMandatoryProductSelection)) {
				return this.groupsWithMissingSelections[this.index] && this.groupsWithMissingSelections[this.index].length > 0;
			}
			if(this.differentiatedGroup && this.differentiatedGroup.products) {
				// if all products from the group are disabled by pickup rules, validation makes no sense
				if(this.differentiatedGroup.products.upsell.length === 0 && this.differentiatedGroup.products.default.length === 0) {
					return false;
				}
				const selectedSubproducts = this.findSelectedSubProducts();
				const selectedupsellProducts = this.differentiatedGroup.products.upsell.filter(p => {
					return selectedSubproducts.includes(p.id);
				});
				const selectedDefaultProducts = this.differentiatedGroup.products.default.filter(p => {
					return selectedSubproducts.includes(p.id);
				});
				return selectedupsellProducts.length === 0 && selectedDefaultProducts.length === 0;
			} else {
				return false;
			}
		},
		subProductHasGroupsOrConfigs(){
			const mainSubproduct = this._item.product.groups.find(g => g.appearance === "single");
			return mainSubproduct !== undefined ? mainSubproduct.products[0].groups.length > 0 || mainSubproduct.products[0].configurations.length > 0 : true;
		},
		isMenu() {
			return (this._item || this.item).product.departmentId === 2;
		}
	},
	methods: {
		findSelectedSubProducts() {
			if(this.subProduct !== null) {
				const selectedProducts = this.productSelections[this.index].groups
					.find(g => g.groupId === this.mainGroup.id).selectedProducts;
				return selectedProducts.find(s => s.groups.find(g => g.groupId === this.differentiatedGroup.id) !== null).groups
					.find(g => g.groupId === this.differentiatedGroup.id).selectedProducts;
			} else {
				return [...this.productSelections[this.index].groups.find(g => g.groupId === this.differentiatedGroup.id).selectedProducts];
			}
		},
		getDifferentiatedGroup() {
			const item = this.item || this._item;
			if (item) {
				const product = item.product;
				if (product.differentiatedGroup) {
					return product.differentiatedGroup;
				} else if(product.groups[0] && product.groups[0].products[0].differentiatedGroup) {
					return product.groups[0].products[0].differentiatedGroup;
				} else {
					return undefined;
				}
			} else {
				return undefined;
			}
		},
		changeGroupProductSelectionIndexWrapped(index) {
			return (changedGroup, value, quantity = undefined) => {
				return this.changeGroupProductSelection(changedGroup, value, index, quantity);
			};
		},
		changeGroupProductSelection(changedGroup, value, index, quantity = undefined) {
			this.productSelections[index].groups = this.productSelections[index].groups.map(group => {
				if (group.groupId === changedGroup.id) {
					if(quantity !== undefined) {
						if(quantity > 0) {
							if(Array.isArray(group.selectedProducts) && group.selectedProducts.length > 0) {
								const foundProduct = group.selectedProducts.find(product => product.productId === value);
								if(foundProduct) {
									foundProduct.quantity = quantity;
								} else {
									group.selectedProducts.push({
										productId: value,
										quantity: quantity
									});
								}
							} else {
								group.selectedProducts = [
									{
										productId: value,
										quantity: quantity
									}
								];
							}
						} else if(quantity === 0) {
							const foundIndex = group.selectedProducts.findIndex(product => product.productId === value);
							if(foundIndex !== -1) {
								group.selectedProducts.splice(foundIndex, 1);
							}
						}
					} else {
						if(!value) {
							group.selectedProducts = [];
						} else {
							group.selectedProducts = Array.isArray(value) ? value : [value];
						}
					}
				}
				return group;
			});
			// we need first group with selectedProducts.length > 0 so we can take first selectedProduct with
			// groups.length > 0
			// the following two variables are intented to find that
			const firstGroupWithSelectedProducts = this.productSelections[index].groups
				.find(group =>group.selectedProducts && group.selectedProducts.length > 0);
			const firstProductSelectionWithGroups = firstGroupWithSelectedProducts ? firstGroupWithSelectedProducts.selectedProducts
				.find(selectedProduct => selectedProduct.groups && selectedProduct.groups.length > 0) : null;
			if(firstProductSelectionWithGroups){
				firstProductSelectionWithGroups.groups = firstProductSelectionWithGroups.groups.map(group => {
					if (group.groupId === changedGroup.id) {
						if(quantity !== undefined) {
							if(quantity > 0) {
								if(Array.isArray(group.selectedProducts) && group.selectedProducts.length > 0) {
									const foundProduct = group.selectedProducts.find(product => product.productId === value);
									if(foundProduct) {
										foundProduct.quantity = quantity;
									} else {
										group.selectedProducts.push({
											productId: value,
											quantity: quantity
										});
									}
								} else {
									group.selectedProducts = [
										{
											productId: value,
											quantity: quantity
										}
									];
								}
							} else if(quantity === 0) {
								const foundIndex = group.selectedProducts.findIndex(product => product.productId === value);
								if(foundIndex !== -1) {
									group.selectedProducts.splice(foundIndex, 1);
								}
							}
						} else {
							group.selectedProducts = Array.isArray(value) ? value : [value];
						}
					}
					return group;
				});
			}
			this.$store.commit(UPDATE_PRODUCT_SELECTIONS, cloneDeep(this.productSelections));
			return this.productSelections[index];
		},
		changeMainSelectionIndexWrapped(index) {
			return (configurationId, optionIndex) => {
				return this.changeMainSelection(configurationId, optionIndex, index);
			};
		},
		changeMainSelection(configurationId, optionIndex, index) {
			this.productSelections[index].configurations
				.find(cp => cp.configurationId === configurationId).selectedValue = optionIndex;
			const allSelectedProducts = this.productSelections[index].groups.map(g => {
				const grp = this._item.product.groups.find(gp => gp.id === g.groupId);
				return g.selectedProducts.map(sp => {
					if(typeof sp === "object") {
						// in amount groups selectedProducts field is an array of {productId, quantity}
						// for these groups both values need to be copied, because you need the quantity of each product as well
						// other group types that also have an array of object type values in selectedProducts
						// only need the productId
						if(grp.appearance === "amount") {
							return {productId: sp.productId, quantity: sp.quantity};
						} else {
							return sp.productId;
						}
					} else {
						return sp;
					}
				});
			});
			const newGroups = this._item.product.groups.map(gp => {
				const options = Object.assign({}, gp.options);
				const groupProductIds = gp.products.map(product => product.id);

				// find currently selected products array which has all the products within this group products ids
				const selectedProducts = allSelectedProducts.find(selectedProducts => {
					if(gp.appearance === "amount") {
						return selectedProducts.length && selectedProducts.every(selectedProduct => groupProductIds.includes(selectedProduct.productId));
					} else {
						return selectedProducts.length && selectedProducts.every(selectedProduct => groupProductIds.includes(selectedProduct));
					}
				});
				// add default selected info to product selection
				options.defaultSelected = gp.options.defaultSelected;

				const selectionGroup = {
					groupId: gp.id,
					selectedProducts: (() => {
						if (selectedProducts) {
							return selectedProducts;
						} else {
							return gp.options.defaultSelected ? [gp.options.defaultSelected] : [];
						}
					})(),
					options: options
				};

				// if product is from conditional group change group
				// else return normal group
				if (gp.options.showIfConfigurationOptionSelected) {
					if (
						gp.options.showIfConfigurationOptionSelected.configurationId === configurationId
						&& gp.options.showIfConfigurationOptionSelected.optionIndex === optionIndex
					) {
						return selectionGroup;
					} else {
						return null;
					}
				} else {
					const existingGroup = this.productSelections[index].groups.find(g => g.groupId === gp.id);
					return existingGroup ? existingGroup : selectionGroup;
				}
			}).filter(group => !!group);
			this.productSelections[index].groups = newGroups.slice();

			this.updateExtraIcons(index, this.productSelections);
			this.$store.commit(UPDATE_PRODUCT_SELECTIONS, cloneDeep(this.productSelections));
		},
		changeSubGroupProductSelectionIndexWrapped(index) {
			return (mainGroup, subProduct, changedGroup, selectedSubproducts) => {
				return this.changeSubGroupProductSelection(mainGroup, subProduct, changedGroup, selectedSubproducts, index);
			};
		},
		changeSubGroupProductSelection(mainGroup, subProduct, changedGroup, selectedSubproducts, index) {
			if(this.isMenu) {
				this.changeSubGroupProductSelectionComposite(mainGroup, subProduct, changedGroup, selectedSubproducts, index);
			} else {
				this.changeSubGroupProductSelectionSimple(mainGroup, subProduct, changedGroup, selectedSubproducts, index);
			}
			this.$store.commit(UPDATE_PRODUCT_SELECTIONS, cloneDeep(this.productSelections));
		},
		changeSubGroupProductSelectionSimple(mainGroup, subProduct, changedGroup, selectedSubproducts, index) {
			this.productSelections[index].groups.find(g => {
				return g.groupId === changedGroup.id;
			}).selectedProducts = [...selectedSubproducts];
		},
		changeSubGroupProductSelectionComposite(mainGroup, subProduct, changedGroup, selectedSubproducts, index) {
			const selectedProducts = this.productSelections[index].groups
				.find(g => g.groupId === mainGroup.id).selectedProducts;
			// if selectedProduct is string change it with object
			if (selectedProducts.includes(subProduct.id)) {
				selectedProducts.splice(selectedProducts.indexOf(subProduct.id), 1);
				selectedProducts.push(ProductSelection.createFromProduct(subProduct));
			}
			selectedProducts.find(p => p.productId === subProduct.id)
				.groups.find(g => g.groupId === changedGroup.id)
				.selectedProducts = [...selectedSubproducts];
		},
		changeConfigSelectionIndexWrapped(index) {
			return (config, selectedOptions, mainGroup, subProduct) => {
				return this.changeConfigSelection(config, index, selectedOptions, mainGroup, subProduct);
			};
		},
		changeConfigSelection(config, index, selectedOptions, mainGroup, subProduct) {
			if(this.isMenu) {
				this.changeConfigSelectionComposite(config, index, selectedOptions, mainGroup, subProduct);
			} else {
				this.changeConfigSelectionSimple(config, index, selectedOptions, mainGroup, subProduct);
			}
			this.$store.commit(UPDATE_PRODUCT_SELECTIONS, cloneDeep(this.productSelections));
		},
		changeConfigSelectionSimple(config, index, selectedOptions) {
			this.productSelections[index].configurations.find(c => c.configurationId === config.id).selectedValue = [...selectedOptions];
		},
		changeConfigSelectionComposite(config, index, selectedOptions, mainGroup, subProduct) {
			this.productSelections[index].groups
				.find(g => g.groupId === mainGroup.id).selectedProducts
				.find(p => p.productId === subProduct.id).configurations
				.find(c => c.configurationId === config.id).selectedValue = [...selectedOptions];
		}
	}
};
